import React from 'react';
import Modal from '../../components/Modal';

const Formulario = props => (
  <Modal title={props.title} idModal='mantenimiento' isOpen={props.isOpen} closeModal={props.closeModal} modalSize='modal-dialog modal-lg'>
    <div className='form-group'>
      <div className='row'>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='familia'>Familia</label>
          <div className='select'>
            <select className='form-control' id='familia' onChange={props.onChangeValue} name='familiaFormulario' value={props.familiaFormulario} disabled={props.disabled}>
              <option disabled value=''>Selecciona una familia</option>
              {
                props.familias.map(familia => (
                  <option
                    key={familia.codFamiliaVeh}
                    value={familia.codFamiliaVeh}
                  >
                    {familia.desFamiliaVeh}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='filial'>Filial</label>
          <div className='select'>
            <select className='form-control' id='filial' onChange={props.onChangeValue} name='filialFormulario' value={props.filialFormulario} disabled={props.disabled}>
              <option disabled value=''>Selecciona una filial</option>
              {
                props.filiales.map(filial => (
                  <option
                    key={filial.id}
                    value={filial.id}
                  >
                    {filial.nombre}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
      </div>
    </div>
    <div className='form-group'>
      <div className='row'>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='unidadMax'>Cantidad Máxima de Unidades</label>
          <input className='form-control' id='unidadMax' onChange={props.onChangeValue} name='unidadMaxFormulario' type='number' value={props.unidadMaxFormulario} min={1} />
        </div>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='unidades'>Tipo de unidad</label>
          <div className='select'>
            <select className='form-control' id='unidades' onChange={props.onChangeValue} name='unidadesFormulario' value={props.unidadesFormulario}>
              <option disabled value=''>Selecciona una tipo de unidad</option>
              <option value='D'>Diario</option>
              <option value='S'>Semanal</option>
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
      </div>
    </div>
    {
      props.disabled ?
        <div className='form-group'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='checkbox'>
                <label htmlFor='activo'>
                  <input type='checkbox' id='activo' name='activo' checked={props.activo} onChange={props.onCheck} />
                  <div className='checkbox-skin' />
                Activo
              </label>
              </div>
            </div>
          </div>
        </div> : null
    }
    <div className='modal-actions'>
      <button className='btn btn-return' onClick={() => props.closeModal()}>Cancelar</button>
      { !props.disabled ?
        <button className='btn btn-primary pull-right' onClick={() => props.create()}>Guardar</button> :
        <button className='btn btn-primary pull-right' onClick={() => props.edit(props.registroSelected)}>Guardar</button>
      }
    </div>
  </Modal>
);

Formulario.defaultProps = {
  isOpen: false,
};

export default Formulario;



// WEBPACK FOOTER //
// ./src/pages/MantLugarDespacho/Formulario.js